// extracted by mini-css-extract-plugin
export default {"Content-ocean":"theme-ocean_Content-ocean__uP4hB","Footer-ocean":"theme-ocean_Footer-ocean__nFqwz"};